/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && (currentUser.access === 'admin' || currentUser.role === 'admin'),
    isUser: currentUser && (currentUser.access === 'user' || currentUser.role === 'user'),
    isAdmin: currentUser && (currentUser.access === 'admin' || currentUser.role === 'admin'),
  };
}
